export default __webpack_public_path__ + "static/media/Gellix-SemiBoldItalic.8138c5e2.woff";